import BusinessImages from 'components/business/BusinessImages';

export default function ProfilePhotos() {
  return <BusinessImages hideButton type="profile" />;
}
